import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 alert alert-info text-center fw-bold",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, "お知らせ", -1)
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted } from 'vue';
  import axios from 'axios';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeBox',
  props: {
    axiosOptions: { type: Object }
  },
  setup(__props) {

const props = __props;

  

  let notice = ref({});
  const getNotice = () => {
    axios.get("get_notice.php", props.axiosOptions)
      .then((response) => {
        if (response.status == 200) {
          if (response.data) {
            notice.value = response.data.html;
          }
        }
      })
      .catch((failCallback) => {
        console.log(failCallback.errMsg);
      });
  }

  onMounted (() => {
    getNotice();
  });

return (_ctx: any,_cache: any) => {
  return (_unref(notice))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "fs-6",
          innerHTML: _unref(notice)
        }, null, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})